import { DealerApiClient, DealerPlacementIds } from '@wix/package-picker-sdk';
import { getSearchParams } from '@wix/package-picker-shared';
import {
  eclipseServerData,
  useAnonymous,
} from '@wix/package-picker-shared-eclipse';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';

interface UseDealerTitleParams {
  isUpgradeFlow: boolean;
}

interface UseDealerTitleResult {
  dealerTitle: string | undefined;
  isLoading: boolean;
}

/**
 * Fetches dealer title from the API. Returns only dealer data; title resolution
 * (default, domain, anonymous, etc.) is handled in useTitleKey.
 */
export const useDealerTitle = ({
  isUpgradeFlow,
}: UseDealerTitleParams): UseDealerTitleResult => {
  const { httpClient } = usePremiumEssentialsContext();
  const { isAnonymous } = useAnonymous();
  const { siteGuid } = getSearchParams();

  const placementId = isUpgradeFlow
    ? DealerPlacementIds.APP_INTENT_SECOND_UPGRADE
    : DealerPlacementIds.APP_INTENT_INITIAL_PURCHASE;
  const { siteAuthorizationType } = eclipseServerData.get();

  const shouldFetch = !!httpClient && !isAnonymous && !!siteGuid;

  const dealerTitleQuery = DealerApiClient.hooks.useGetDealerTitle(
    {
      placementId,
      siteId: siteGuid,
      siteAuthorizationType,
    },
    shouldFetch,
  );

  const dealerTitle = dealerTitleQuery.data?.title;
  const isLoading = dealerTitleQuery.isLoading;

  return {
    dealerTitle,
    isLoading,
  };
};
